<template>
  <path
    d="M12 2.00024C6.5 2.00024 2 6.50024 2 12.0002C2 17.5002 6.5 22.0002 12 22.0002C17.5 22.0002 22 17.5002 22 12.0002C22 6.50024 17.5 2.00024 12 2.00024ZM15.55 15.8002L11.47 13.2902C11.17 13.1102 10.99 12.7902 10.99 12.4402V7.75024C11 7.34024 11.34 7.00024 11.75 7.00024C12.16 7.00024 12.5 7.34024 12.5 7.75024V12.2002L16.34 14.5102C16.7 14.7302 16.82 15.2002 16.6 15.5602C16.38 15.9102 15.91 16.0202 15.55 15.8002Z"
  />
</template>
